module.exports = __webpack_public_path__ + "img/tarjeta_video_preview.d6178c7.png";